
import { MapLocation } from '@/types/location';

// Create a placeholder for Alan Cafe Locations
// This file should be populated with actual cafe locations in the future
export const alanCafeLocations: MapLocation[] = [];
